(function () {
  'use strict';

  if (window.PrewornAccountLoaded) return;
  window.PrewornAccountLoaded = true;

  var AI_LOOK_JOB_KEY = 'preworn:ai-look-job:v1';
  var AI_LOOK_JOB_TIMEOUT = 4 * 60 * 1000;
  var aiLookPollTimer = 0;
  var aiLookSaveInflight = false;

  function readAiLookJob() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(AI_LOOK_JOB_KEY) || 'null');
      return stored && typeof stored === 'object' ? stored : null;
    } catch (error) {
      return null;
    }
  }

  function writeAiLookJob(job) {
    try { window.localStorage.setItem(AI_LOOK_JOB_KEY, JSON.stringify(job)); } catch (error) {}
  }

  function aiLookElapsed(startedAt, completedAt) {
    var end = Number(completedAt || Date.now());
    var seconds = Math.max(0, Math.floor((end - Number(startedAt || end)) / 1000));
    var minutes = Math.floor(seconds / 60);
    return (minutes < 10 ? '0' : '') + minutes + ':' + (seconds % 60 < 10 ? '0' : '') + (seconds % 60);
  }

  function aiLookProgress(startedAt) {
    var seconds = Math.max(0, Math.floor((Date.now() - Number(startedAt || Date.now())) / 1000));
    if (seconds < 7) return Math.min(20, 6 + seconds * 2);
    if (seconds < 18) return Math.min(43, 20 + (seconds - 7) * 2.1);
    if (seconds < 52) return Math.min(82, 43 + (seconds - 18) * 1.15);
    return Math.min(94, 82 + (seconds - 52) * .18);
  }

  function aiLookBuilderUrl(job) {
    var fallback = '/pages/build-an-outfit';
    try {
      var url = new URL(String(job && job.returnUrl || fallback), window.location.origin);
      if (url.origin !== window.location.origin) return fallback + '#ai-look-preview';
      if (job && /^\d+$/.test(String(job.savedOutfitId || ''))) {
        url.searchParams.set('edit_outfit', String(job.savedOutfitId));
      }
      url.hash = 'ai-look-preview';
      return url.pathname + url.search + url.hash;
    } catch (error) {
      return fallback + '#ai-look-preview';
    }
  }

  function saveCompletedAiLook(job) {
    if (aiLookSaveInflight || !job || job.status !== 'ready' || !job.imageUrl ||
        !job.previewSignature || !job.saveEndpoint || !job.savePayload ||
        job.saveStatus === 'saved') return;
    aiLookSaveInflight = true;
    job.saveStatus = 'saving';
    job.saveError = '';
    writeAiLookJob(job);
    syncAiLookNotice(job);
    var payload = Object.assign({}, job.savePayload, {
      previewSignature: String(job.previewSignature || ''),
      previewImageUrl: String(job.imageUrl || '')
    });
    window.fetch(String(job.saveEndpoint), {
      method: String(job.saveMethod || 'POST').toUpperCase(),
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok || body.error || !body.outfit) {
          throw new Error(body.error || 'outfit_not_saved');
        }
        return body.outfit;
      });
    }).then(function (outfit) {
      var current = readAiLookJob();
      if (!current || current.jobId !== job.jobId) return;
      current.saveStatus = 'saved';
      current.saveError = '';
      current.savedOutfitId = outfit.id || current.savedOutfitId || '';
      writeAiLookJob(current);
      syncAiLookNotice(current);
      window.dispatchEvent(new CustomEvent('preworn:outfits-change'));
    }).catch(function (error) {
      var current = readAiLookJob();
      if (!current || current.jobId !== job.jobId) return;
      current.saveStatus = 'error';
      current.saveError = error && error.message ? error.message : 'outfit_not_saved';
      writeAiLookJob(current);
      syncAiLookNotice(current);
    }).then(function () {
      aiLookSaveInflight = false;
    });
  }

  function ensureAiLookNotice() {
    var notice = document.querySelector('[data-pw-account-ai-look]');
    if (notice) return notice;
    notice = document.createElement('aside');
    notice.className = 'pwaccount-ai-look';
    notice.setAttribute('data-pw-account-ai-look', '');
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.hidden = true;
    notice.innerHTML = '<button type="button" class="pwaccount-ai-look__dismiss" data-pw-account-ai-look-dismiss aria-label="Dismiss AI look update">×</button>' +
      '<span class="pwaccount-ai-look__icon" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="m12 2 1.5 5.1L18 9l-4.5 1.9L12 16l-1.5-5.1L6 9l4.5-1.9L12 2Z"></path><path d="m19 15 .8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z"></path></svg></span>' +
      '<span class="pwaccount-ai-look__copy"><small data-pw-account-ai-look-eyebrow>AI OUTFIT PREVIEW</small><strong data-pw-account-ai-look-title>Your look is being created.</strong><span data-pw-account-ai-look-meta>You can keep browsing.</span><i><b data-pw-account-ai-look-progress></b></i></span>' +
      '<a class="pwaccount-ai-look__action" data-pw-account-ai-look-action href="/pages/build-an-outfit">VIEW PROGRESS</a>';
    document.body.appendChild(notice);
    notice.querySelector('[data-pw-account-ai-look-dismiss]').addEventListener('click', function () {
      try { window.localStorage.removeItem(AI_LOOK_JOB_KEY); } catch (error) {}
      notice.hidden = true;
    });
    return notice;
  }

  function syncAiLookNotice(job) {
    if (document.querySelector('[data-pw-outfit-builder]')) return;
    var notice = ensureAiLookNotice();
    if (!job || !job.startedAt) {
      notice.hidden = true;
      return;
    }
    var ready = job.status === 'ready' && job.imageUrl;
    var failed = job.status === 'error';
    notice.hidden = false;
    notice.classList.toggle('is-ready', !!ready);
    notice.classList.toggle('is-error', !!failed);
    var eyebrow = notice.querySelector('[data-pw-account-ai-look-eyebrow]');
    var title = notice.querySelector('[data-pw-account-ai-look-title]');
    var meta = notice.querySelector('[data-pw-account-ai-look-meta]');
    var progress = notice.querySelector('[data-pw-account-ai-look-progress]');
    var action = notice.querySelector('[data-pw-account-ai-look-action]');
    var dismiss = notice.querySelector('[data-pw-account-ai-look-dismiss]');
    if (eyebrow) eyebrow.textContent = ready ? 'YOUR AI LOOK IS READY' : failed ? 'AI LOOK NEEDS ATTENTION' : 'AI LOOK IN PROGRESS';
    if (title) title.textContent = ready ? 'Your new outfit preview is ready.' : failed
      ? 'Your preview could not be completed.' : 'Your look is being created.';
    if (meta) meta.textContent = ready
      ? 'Completed in ' + aiLookElapsed(job.startedAt, job.completedAt) +
        (job.saveStatus === 'saving' ? ' · Saving to My Outfits…' :
          job.saveStatus === 'saved' ? ' · Saved to My Outfits' :
            job.saveStatus === 'error' ? ' · Preview ready; save needs another try' : ' · Tap to view it')
      : failed ? (job.error || 'Return to the outfit builder and try again.')
        : aiLookElapsed(job.startedAt) + ' elapsed · Browse anywhere; we will update you here';
    if (progress) progress.style.width = (ready || failed ? 100 : aiLookProgress(job.startedAt)) + '%';
    if (dismiss) dismiss.hidden = !ready && !failed;
    if (action) {
      action.textContent = ready ? 'VIEW LOOK' : failed ? 'TRY AGAIN' : 'VIEW PROGRESS';
      action.href = aiLookBuilderUrl(job);
      action.removeAttribute('target');
      action.removeAttribute('rel');
    }
  }

  function aiLookStatusUrl(endpoint, jobId) {
    var url = new URL(endpoint, window.location.href);
    url.searchParams.set('job', jobId);
    return url.toString();
  }

  function scheduleAiLookPoll(delay) {
    if (aiLookPollTimer) window.clearTimeout(aiLookPollTimer);
    aiLookPollTimer = window.setTimeout(pollAiLookJob, delay || 2500);
  }

  function transientAiLookError(error) {
    var message = String(error && error.message || error || '').toLowerCase();
    return !error || !error.pwTerminal || /failed to fetch|network|load failed|connection|cors/.test(message);
  }

  function pollAiLookJob() {
    var job = readAiLookJob();
    if (job && job.status === 'error' && job.jobId &&
        /failed to fetch|network|load failed|connection|cors/i.test(String(job.error || '')) &&
        Date.now() - Number(job.startedAt || Date.now()) <= AI_LOOK_JOB_TIMEOUT) {
      job.status = 'working';
      job.completedAt = 0;
      job.error = '';
      writeAiLookJob(job);
    }
    syncAiLookNotice(job);
    if (!job || job.status === 'error') return;
    if (job.status === 'ready') {
      saveCompletedAiLook(job);
      return;
    }
    if (Date.now() - Number(job.startedAt || Date.now()) > AI_LOOK_JOB_TIMEOUT) {
      job.status = 'error';
      job.completedAt = Date.now();
      job.error = 'The preview is taking longer than expected. Return to the outfit builder and try again.';
      writeAiLookJob(job);
      syncAiLookNotice(job);
      return;
    }
    if (!job.endpoint || !/^[a-f0-9]{64}$/i.test(String(job.jobId || ''))) {
      scheduleAiLookPoll(1000);
      return;
    }
    window.fetch(job.endpoint, {
      method: 'POST',
      mode: 'cors',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ status: true, job: job.jobId })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (data) {
        if (!response.ok && response.status !== 202) {
          var responseError = new Error(data && data.message ? data.message : 'The outfit could not be visualised.');
          responseError.pwTerminal = true;
          throw responseError;
        }
        return data;
      });
    }).then(function (data) {
      if (data && data.status === 'ready' && data.image) {
        job.status = 'ready';
        job.completedAt = Date.now();
        job.imageUrl = String(data.image || '');
        job.previewSignature = String(data.previewSignature || job.jobId || '');
        job.error = '';
        writeAiLookJob(job);
        syncAiLookNotice(job);
        saveCompletedAiLook(job);
        var notice = document.querySelector('[data-pw-account-ai-look]');
        if (notice) {
          notice.classList.remove('is-notifying');
          window.setTimeout(function () { notice.classList.add('is-notifying'); }, 20);
        }
        if (document.hidden && 'Notification' in window && window.Notification.permission === 'granted') {
          try { new window.Notification('Your Preworn AI look is ready', { body: 'Open your account to view it.', tag: 'preworn-ai-look-ready' }); } catch (error) {}
        }
        return;
      }
      scheduleAiLookPoll(2500);
    }).catch(function (error) {
      if (transientAiLookError(error)) {
        job.status = 'working';
        job.completedAt = 0;
        job.error = '';
        writeAiLookJob(job);
        syncAiLookNotice(job);
        scheduleAiLookPoll(3500);
        return;
      }
      job.status = 'error';
      job.completedAt = Date.now();
      job.error = error && error.message ? error.message : 'The outfit could not be visualised.';
      writeAiLookJob(job);
      syncAiLookNotice(job);
    });
  }

  function initialiseAiLookMonitor() {
    if (document.querySelector('[data-pw-outfit-builder]')) return;
    syncAiLookNotice(readAiLookJob());
    pollAiLookJob();
  }

  function wishlistCount() {
    try {
      var raw = window.localStorage.getItem('preworn:wishlist');
      var items = raw ? JSON.parse(raw) : [];
      return Array.isArray(items) ? items.length : 0;
    } catch (error) {
      return 0;
    }
  }

  function updateWishlist() {
    var count = wishlistCount();
    var nodes = document.querySelectorAll('[data-pw-account-wishlist]');
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].textContent = count > 99 ? '99+' : String(count);
      nodes[i].hidden = nodes[i].tagName.toLowerCase() === 'em' && count === 0;
    }
  }

  function setOutfitCount(value) {
    var count = Math.max(0, Number(value) || 0);
    var nodes = document.querySelectorAll('[data-pw-account-outfits]');
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].textContent = count > 99 ? '99+' : String(count);
      nodes[i].hidden = nodes[i].tagName.toLowerCase() === 'em' && count === 0;
    }
  }

  function updateOutfitCount() {
    if (!document.querySelector('[data-pw-account-outfits]')) return;
    if (document.querySelector('[data-pw-saved-outfits]')) return;
    window.fetch('/apps/preworn/wardrobes/outfits/count', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('outfits_unavailable');
      return response.json();
    }).then(function (payload) {
      setOutfitCount(payload.count);
    }).catch(function () {});
  }

  function setSearchHistoryCount(value) {
    var count = Math.max(0, Number(value) || 0);
    var nodes = document.querySelectorAll('[data-pw-account-search-count]');
    for (var i = 0; i < nodes.length; i += 1) {
      nodes[i].textContent = count > 999 ? '999+' : String(count);
      nodes[i].hidden = false;
    }
  }

  function searchHistoryDate(value) {
    var raw = String(value || '').trim();
    var date = new Date(raw.indexOf('T') === -1 ? raw.replace(' ', 'T') + 'Z' : raw);
    if (isNaN(date.getTime())) return raw;
    try {
      return new Intl.DateTimeFormat('en-GB', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      }).format(date);
    } catch (error) {
      return date.toLocaleString();
    }
  }

  function searchHistoryMarkup(item) {
    var count = Math.max(0, Number(item.resultCount) || 0);
    var context = item.wardrobeActive ? 'My Wardrobe' : 'Catalogue';
    if (item.contextType === 'collection' && item.contextTitle) {
      context += ' · ' + item.contextTitle;
    }
    var results = count.toLocaleString ? count.toLocaleString('en-GB') : String(count);
    results += count === 1 ? ' result' : ' results';
    return '<a class="pwaccount__history-row" href="' + authEscape(authSafeUrl(item.url, '/search')) + '">' +
      '<span class="pwaccount__history-query"><strong>' + authEscape(item.query || 'Search') + '</strong>' +
      '<small>' + authEscape(context) + '</small></span>' +
      '<span class="pwaccount__history-results' + (count === 0 ? ' is-zero' : '') + '">' + authEscape(results) + '</span>' +
      '<time datetime="' + authEscape(item.searchedAt || '') + '">' + authEscape(searchHistoryDate(item.searchedAt)) + '</time>' +
      '<span aria-hidden="true">↗</span></a>';
  }

  function renderSearchHistory(root, payload) {
    var searches = payload && Array.isArray(payload.searches) ? payload.searches : [];
    var total = Math.max(0, Number(payload && payload.total) || 0);
    setSearchHistoryCount(total);
    if (!root) return;
    var loading = root.querySelector('[data-pw-search-history-loading]');
    var list = root.querySelector('[data-pw-search-history-list]');
    var empty = root.querySelector('[data-pw-search-history-empty]');
    var error = root.querySelector('[data-pw-search-history-error]');
    var clear = root.querySelector('[data-pw-search-history-clear]');
    if (loading) loading.hidden = true;
    if (error) error.hidden = true;
    if (list) {
      list.innerHTML = searches.map(searchHistoryMarkup).join('');
      list.hidden = searches.length === 0;
    }
    if (empty) empty.hidden = searches.length !== 0;
    if (clear) clear.disabled = total === 0;
  }

  function loadSearchHistory() {
    var root = document.querySelector('[data-pw-search-history]');
    var count = document.querySelector('[data-pw-account-search-count]');
    if (!root && !count) return;
    var endpoint = root ? root.getAttribute('data-endpoint') : '/apps/preworn/wardrobes/search-history';
    var url = endpoint + (endpoint.indexOf('?') === -1 ? '?' : '&') + 'limit=' + (root ? '20' : '1');
    window.fetch(url, {
      credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('search_history_unavailable');
      return response.json();
    }).then(function (payload) {
      renderSearchHistory(root, payload);
    }).catch(function () {
      if (!root) return;
      var loading = root.querySelector('[data-pw-search-history-loading]');
      var error = root.querySelector('[data-pw-search-history-error]');
      if (loading) loading.hidden = true;
      if (error) error.hidden = false;
    });
  }

  function clearBrowserSearchIdentity() {
    try {
      window.localStorage.removeItem('preworn:shopping-profile:v1');
      window.sessionStorage.removeItem('preworn:shopping-profile-session:v1');
      window.sessionStorage.removeItem('preworn:shopping-session:v1');
      window.sessionStorage.removeItem('preworn:shopping-profile-linked:v1');
      window.sessionStorage.removeItem('preworn:search-analytics:pending-v1');
    } catch (error) {}
    try {
      window.dispatchEvent(new CustomEvent('preworn:search-profile-cleared'));
    } catch (error) {}
  }

  function clearAccountSearchHistory(button) {
    var root = button.closest('[data-pw-search-history]');
    if (!root || button.disabled) return;
    var confirmed = window.confirm(
      'Clear search history from your account and reset personalised search recommendations? Anonymous search totals will be retained.'
    );
    if (!confirmed) return;
    var endpoint = root.getAttribute('data-endpoint') || '/apps/preworn/wardrobes/search-history';
    var status = root.querySelector('[data-pw-search-history-status]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Clearing your account association…';
    window.fetch(endpoint, {
      method: 'DELETE', credentials: 'same-origin', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('search_history_clear_failed');
      return response.json();
    }).then(function (payload) {
      if (!payload || payload.cleared !== true || payload.aggregateEventsRetained !== true) {
        throw new Error('search_history_clear_incomplete');
      }
      clearBrowserSearchIdentity();
      renderSearchHistory(root, { searches: [], total: 0 });
      if (status) status.textContent = 'Your account association has been removed. Anonymous search totals were retained.';
    }).catch(function () {
      button.disabled = false;
      if (status) status.textContent = 'We could not clear your search history. Please try again.';
    }).then(function () {
      button.removeAttribute('aria-busy');
    });
  }

  function setAuthMode(mode) {
    var root = document.querySelector('[data-pw-auth]');
    if (!root) return;
    var recover = mode === 'recover';
    var login = root.querySelector('[data-pw-auth-login]');
    var reset = root.querySelector('[data-pw-auth-recover]');
    if (login) login.hidden = recover;
    if (reset) reset.hidden = !recover;
    if (recover) window.location.hash = 'recover';
    else if (window.location.hash === '#recover') history.replaceState(null, '', window.location.pathname + window.location.search);
    var heading = root.querySelector(recover ? '[data-pw-recover-heading]' : '[data-pw-login-heading]');
    if (heading) heading.focus();
  }

  function authEscape(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function authSafeUrl(value, fallback) {
    var raw = String(value || '').trim();
    return /^(?:https?:)?\/\//i.test(raw) || raw.charAt(0) === '/' ? raw : (fallback || '#');
  }

  function authMoney(amount, currency) {
    var value = Number(amount) || 0;
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: currency || 'GBP' }).format(value);
    } catch (error) {
      return '£' + value.toFixed(2);
    }
  }

  function authTierPrice(product) {
    var price = product && product.priceRange && product.priceRange.minVariantPrice || {};
    var original = Math.max(0, Number(price.amount) || 0);
    var percent = 55;
    var multiplier = 0.45;
    if (!original) { percent = 0; multiplier = 0; }
    else if (original <= 5) { percent = 10; multiplier = 0.90; }
    else if (original <= 10) { percent = 20; multiplier = 0.80; }
    else if (original <= 15) { percent = 30; multiplier = 0.70; }
    else if (original <= 20) { percent = 40; multiplier = 0.60; }
    else if (original < 30) { percent = 45; multiplier = 0.55; }
    return {
      original: original,
      current: Math.round(original * multiplier * 100) / 100,
      percent: percent,
      currency: String(price.currencyCode || 'GBP')
    };
  }

  function authStockTitle(product) {
    var attributes = product && product.attributes || {};
    var style = String(attributes.style || '').trim();
    var type = String(attributes.type || '').trim();
    if (style && type && style.toLowerCase() !== type.toLowerCase()) return style + ' ' + type;
    return style || type || String(product && product.title || 'One-off piece').replace(/\s+/g, ' ').trim();
  }

  function authStockMarkup(product) {
    var pricing = authTierPrice(product);
    var title = authStockTitle(product);
    var image = product && product.featuredImage || {};
    var href = authSafeUrl(product && product.onlineStoreUrl, product && product.handle
      ? '/products/' + encodeURIComponent(product.handle) : '#');
    return '<a class="pwauth__stock-card" href="' + authEscape(href) + '" target="_blank" rel="noopener noreferrer" aria-label="View ' + authEscape(title) + '">' +
      '<span class="pwauth__stock-media"><img src="' + authEscape(authSafeUrl(image.url, '')) + '" alt="' + authEscape(image.altText || title) + '" loading="eager">' +
      '<i>' + pricing.percent + '%<small>OFF</small></i></span>' +
      '<span class="pwauth__stock-copy"><small>' + authEscape(product.vendor || 'PREWORN') + '</small><strong>' + authEscape(title) + '</strong>' +
      '<span><s>' + authMoney(pricing.original, pricing.currency) + '</s><b>' + authMoney(pricing.current, pricing.currency) + '</b></span></span></a>';
  }

  function loadAuthStock() {
    var root = document.querySelector('[data-pw-auth-stock]');
    if (!root || typeof window.fetch !== 'function') return;
    var endpoint = root.getAttribute('data-catalog-api');
    var grid = root.querySelector('[data-pw-auth-stock-grid]');
    var note = root.querySelector('[data-pw-auth-stock-note]');
    if (!endpoint || !grid) { root.hidden = true; return; }
    var url = new URL(endpoint, window.location.href);
    url.searchParams.set('action', 'search');
    url.searchParams.set('page', '1');
    url.searchParams.set('limit', '8');
    url.searchParams.set('sort', 'newest');
    url.searchParams.set('new_in', '1');
    url.searchParams.set('window_days', '28');
    url.searchParams.set('include_facets', '0');
    url.searchParams.set('count_mode', 'none');
    window.fetch(url.toString(), {
      mode: 'cors', credentials: 'omit', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('stock_unavailable');
      return response.json();
    }).then(function (payload) {
      var items = payload && Array.isArray(payload.items) ? payload.items.filter(function (item) {
        return item && item.availableForSale !== false && item.handle && item.featuredImage && item.featuredImage.url;
      }).slice(0, 4) : [];
      if (!items.length) throw new Error('stock_empty');
      grid.innerHTML = items.map(authStockMarkup).join('');
      grid.setAttribute('aria-busy', 'false');
      if (note) note.textContent = 'Real products available now. One-off means once it’s gone, it’s gone.';
    }).catch(function () {
      root.hidden = true;
    });
  }

  function updateProvinces(country, applyDefault) {
    var formId = country.getAttribute('data-address-country');
    var province = document.querySelector('[data-address-province="' + formId + '"]');
    var wrap = document.querySelector('[data-address-province-wrap="' + formId + '"]');
    if (!province || !wrap) return;
    var defaultCountry = country.getAttribute('data-default');
    if (applyDefault && defaultCountry) country.value = defaultCountry;
    var selected = country.options[country.selectedIndex];
    var raw = selected ? selected.getAttribute('data-provinces') : '[]';
    var provinces = [];
    try { provinces = JSON.parse(raw || '[]'); } catch (error) { provinces = []; }
    var previous = applyDefault ? (province.getAttribute('data-default') || '') : province.value;
    province.innerHTML = '';
    for (var i = 0; i < provinces.length; i += 1) {
      var option = document.createElement('option');
      option.value = provinces[i][0];
      option.textContent = provinces[i][1];
      option.selected = provinces[i][0] === previous;
      province.appendChild(option);
    }
    wrap.hidden = provinces.length === 0;
  }

  document.addEventListener('click', function (event) {
    var authToggle = event.target.closest('[data-pw-auth-mode]');
    if (authToggle) {
      event.preventDefault();
      setAuthMode(authToggle.getAttribute('data-pw-auth-mode'));
      return;
    }
    var deleteButton = event.target.closest('[data-pw-address-delete]');
    if (deleteButton) {
      if (!window.confirm(deleteButton.getAttribute('data-confirm') || 'Delete this address?')) event.preventDefault();
      return;
    }
    var clearSearchButton = event.target.closest('[data-pw-search-history-clear]');
    if (clearSearchButton) {
      clearAccountSearchHistory(clearSearchButton);
      return;
    }
    var editLink = event.target.closest('a[href^="#EditAddress_"]');
    if (editLink) {
      var editor = document.querySelector(editLink.getAttribute('href'));
      if (editor) editor.open = true;
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-address-country]')) updateProvinces(event.target, false);
  });

  function initialise() {
    updateWishlist();
    updateOutfitCount();
    loadSearchHistory();
    loadAuthStock();
    initialiseAiLookMonitor();
    var countries = document.querySelectorAll('[data-address-country]');
    for (var i = 0; i < countries.length; i += 1) updateProvinces(countries[i], true);
    if (window.location.hash === '#recover') setAuthMode('recover');
    if (window.location.hash.indexOf('#EditAddress_') === 0) {
      var editor = document.querySelector(window.location.hash);
      if (editor) editor.open = true;
    }
  }

  window.addEventListener('storage', function (event) {
    if (event.key === 'preworn:wishlist') updateWishlist();
    if (event.key === AI_LOOK_JOB_KEY) {
      syncAiLookNotice(readAiLookJob());
      scheduleAiLookPoll(50);
    }
  });
  window.addEventListener('preworn:ai-look-job', function () {
    syncAiLookNotice(readAiLookJob());
    scheduleAiLookPoll(50);
  });
  window.addEventListener('preworn:wishlist-change', updateWishlist);
  window.addEventListener('preworn:outfits-change', function (event) {
    var count = event.detail && Number(event.detail.count);
    if (typeof count === 'number' && isFinite(count)) setOutfitCount(count); else updateOutfitCount();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
})();
